if (!customElements.get('aur-aviso-faixa2')) {
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (sessionStorage.getItem('cc-theme-announcement-dismissed') === 'true' && !Shopify.designMode) {
        this.hidden = true;
        return;
      }

      this.announcement = this.querySelector('.aur-aviso');
      this.backgrounds = this.querySelectorAll('.aur-aviso-te');

      const observer = new MutationObserver(this.mutationCallback.bind(this));
      const config = { attributes: true, attributeFilter: ['class'] };
      this.querySelectorAll('.aur-sequencia__lamina').forEach((el) => {
        observer.observe(el, config);
      });

      this.querySelector('.aur-aviso__encerrar').addEventListener('click', this.close.bind(this));
    }

    mutationCallback(mutationList) {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          if (mutation.target.classList.contains('aur-bi-ativo2')) {
            this.setActiveSlide(mutation.target);
          }
        }
      }
    }

    setActiveSlide(slide) {
      this.style.setProperty('--aur-announcement-text-color', slide.dataset.aurVerboTom);
      this.backgrounds.forEach((el) => {
        el.classList.toggle('aur-bi-ativo2', el.dataset.aurDize === slide.dataset.aurDize);
      });
    }

    close() {
      sessionStorage.setItem('cc-theme-announcement-dismissed', 'true');
      this.hidden = true;
    }
  }

  customElements.define('aur-aviso-faixa2', AnnouncementBar);
}
